import React, { memo, useCallback, useMemo } from 'react';
import './index.scss';
import { Calendar, CalendarEvent, CalendarView } from '@modules/common/Calendar';
import { toMoment } from '@core/utils/time';
import { TaskId, TaskResponse } from '@business/entities/task';
import { openAddEditTaskModal } from '@modules/dashboard/DashboardPage/TasksMenu/AddEditTaskModal';
import { CBody } from '@modules/common/CBody';
import { TodosPageBloc } from '@modules/TodosPage/TodosPageBloc';
import { useHistory } from '@core/router';
import { openTaskOverlay } from '@modules/tasks/TaskDetailModal';

interface CalendarTaskListProps {
  allTasks: TaskResponse[];
  bloc: TodosPageBloc;
  isCompleted?: boolean;
}
export const CalendarTaskList = memo((props: CalendarTaskListProps) => {
  const { allTasks, bloc, isCompleted = false } = props;
  const history = useHistory();
  const tasks = useMemo(() => allTasks.filter(o => o.dueDate && (isCompleted ? !!o.completedAt : !o.completedAt)), [allTasks, isCompleted]);

  const onUpdate = useCallback(
    (id: TaskId, task: Partial<TaskResponse>) => {
      bloc.updateTask(id, task, true).subscribe();
    },
    [bloc],
  );

  const taskEvents = useMemo(() => {
    const allTasks: CalendarEvent[] = [];
    tasks.map(o => {
      allTasks.push({
        id: o.id,
        title: o.title,
        start: toMoment(o.dueDate).startOf('day').unix(),
        item: o,
        backgroundColor: o.status?.color,
        menuOrder: o.menuOrder,
      });
      o.children.map(c => {
        allTasks.push({
          id: c.id,
          title: c.title,
          start: toMoment(c.dueDate).startOf('day').unix(),
          item: c,
          backgroundColor: c.status?.color,
          menuOrder: c.menuOrder,
        });
      });
    });
    return allTasks;
  }, [tasks]);

  const onClose = useCallback(() => {
    bloc.onReload();
  }, [bloc]);

  const onClick = useCallback(
    (taskId: TaskId) => {
      //   openTaskOverlay({ taskId, onClose });
      history.push(`/todos/calendar/task/${taskId}`);
      //   openAddEditTaskModal({ id: taskId, onDone: () => bloc.onReload() });
    },
    [history],
  );

  return (
    <CBody>
      <Calendar
        displayEventTime={false}
        onDayClick={d => openAddEditTaskModal({ dueDate: d.endOf('day').unix(), onDone: () => bloc.onReload() })}
        onEventClick={(id, item) => onClick(id)}
        onEventChange={(id, item, start, end) => onUpdate(id, { dueDate: toMoment(start).endOf('day').unix() })}
        eventOrder="menuOrder"
        types={[CalendarView.month]}
        events={taskEvents}
      />
    </CBody>
  );
});
